<template>
  <div
    @click="$emit('click')"
    @keyup.enter="$emit('click')"
    :id="'tab_' + title.toLowerCase().replace(/ /g, '_')"
    :class="containerClass"
    class="pa-4 d-flex align-center focus-visible"
    tabindex="0"
  >
    <template v-if="!hideIcon">
      <v-icon
        v-if="locked"
        :class="heavyActive"
        :disabled="locked"
        class="me-2"
        color="gray"
        icon="lock_outline"
        size="22"
      />

      <v-icon
        v-if="progress == 100"
        :class="heavyActive"
        class="me-2"
        color="green"
        icon="check_circle"
        size="22"
      />

      <v-progress-circular
        v-if="!locked && progress < 100"
        :model-value="progress"
        class="me-2"
        size="22"
        width="2"
      />
    </template>
    <div>
      <div
        :class="heavyActive"
        class="fs-16"
      >
        {{ $bct(title) }}
      </div>
    </div>
    <v-spacer />
    <v-icon icon="chevron_right" />
  </div>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  dividedBottom: {
    type: Boolean,
    default: false,
  },
  hideIcon: {
    type: Boolean,
    default: false,
  },
  locked: {
    type: Boolean,
    default: false,
  },
  progress: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: null,
  },
});

defineEmits(['click']);

const $bct = inject('translator');

const heavyActive = computed(() => (props.active ? 'fw-600' : 'fw-500'));

const containerClass = computed(() => {
  const classes = [];
  if (props.dividedBottom) {
    classes.push('bb-1 bc-very-light-gray');
  }

  if (props.locked) {
    classes.push('cursor-default');
  } else {
    classes.push('pointer');
  }

  return classes.join(' ');
});
</script>
